import React from 'react'
import FundraiserEditProfileFormPage from '../../components/Fundraiser/EditProfileForm';

const EditProfileForm = () => {
  return (
    <FundraiserEditProfileFormPage />
  )
}

export default EditProfileForm;


